import axios from 'axios';
import { message } from 'antd';

const api = axios.create({
  baseURL: '/api/v1',
  timeout: 15000,
});

// 请求拦截：添加 token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截：错误处理
api.interceptors.response.use(
  (res) => res.data,
  (err) => {
    if (err.response?.status === 401) {
      message.error('登录已过期，请重新登录');
      localStorage.removeItem('admin_token');
      window.location.href = '/admin';
    } else if (err.response?.status === 403) {
      message.error((err.response?.data && err.response.data.error) || '无权限操作');
    }
    return Promise.reject(err.response?.data || err);
  }
);

export default api;
